module.exports = {"id":"tiro-security","title":"Tiro Security","priority":70,"date_start":"2015-07-01T00:00:00.000Z","date_end":"2015-08-01T00:00:00.000Z","domain":"tirosec.com","tags":["Website","Video","WordPress","Job Listings"],"cover":"tiro-security.png","lead":null,"__content":""}


//////////////////
// WEBPACK FOOTER
// ./client/projects/data/tiro-security.md
// module id = 267
// module chunks = 0